import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { Post } from 'src/models/blog';

@Component({
  selector: 'app-blog-detalhes',
  templateUrl: './blog-detalhes.component.html',
  styleUrls: ['./blog-detalhes.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlogDetalhesComponent {
  id!: number;
  lines?: any[];
  categoria?: any[];

  tags: any[] = [];
  index: any;
  loadedPost = false;
  filtroCategoria: any = null;
  filtroTag: any = null;
  post: Post | undefined;
  posts: Post[] = [];
  postsVejaTmb: Post[] = [];
  postsHighlights: Post[] = [];
  postCategoria = '';
  categoriaId: string = '';
  tagId: string = '';
  inscricao: any;
  conteudoHtmlSeguro: any;
  quantityPostWithOutCategory = 0

  constructor(
    public apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private el: ElementRef,
    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {

    this.loadedPost = false;
    this.inscricao = this.route.params.subscribe(
      (params: any) => {
        if (params['categoriaId'] != undefined) {
          this.filtroCategoria = params['categoriaId'];
          this.loadBlogCategoria();
        } if (params['id'] != undefined) {
          this.id = +params['id'];
          this.loadPosts();
        }
        if (params['tagId'] != undefined) {
          this.filtroTag = params['tagId'];
          this.loadBlogTags();
        }
      }
    )

    this.loadPosts();
    this.loadBlogCategoria();
    this.loadBlogTags();

  }

  loadPosts() {
    this.apiService.loadPosts().subscribe(data => {
      this.posts = data
      this.verifyPostsWithoutCategory()
      if (this.id) {
        this.post = this.posts.find(p => p.id == this.id)
        this.loadVejaTmb();
      }
      this.conteudoHtmlSeguro = this.sanitizer.bypassSecurityTrustHtml(this.post?.content.rendered);

    })

  }

  verifyPostsWithoutCategory() {
    this.quantityPostWithOutCategory = 0
    this.posts.map(p => {
      if (p.categories.length == 0) { this.quantityPostWithOutCategory++ }
    })
  }

  loadVejaTmb() {
    let i = 0
    while (this.postsVejaTmb.length != 2) {
      if (this.posts[i].id != this.post!.id) {
        this.postsVejaTmb.push(this.posts[i])
      }
      i++
    }
  }

  openPost(post: Post) {
    this.router.navigate([`/blog/detalhes/${post.id}`]);
  }
  openCategoriaId(categoria: any = undefined) {
    if(categoria){
      this.router.navigate([`/blog/categoria/${categoria.id}`])
    } else
      this.router.navigate([`/blog/categoria/0`])

  }
  openTag(tag: any) {
    this.router.navigate([`/blog/tags/${tag.id}`])
  }

  loadBlogCategoria() {
    this.apiService.getPostsCategories().subscribe((data) => {
      this.categoria = data;
    });
  }
  loadBlogTags() {
    this.apiService.getTags().subscribe(itens => {
      this.tags = [];
      for(let i = 0; i < itens.length; i++) {
        if(itens[i].count >= 1) {
          this.tags.push(itens[i]);
        }
      }
      });
  }

}
